import React from "react";
import { SPECIALTY_OPTIONS } from "./constants";

const DashboardControls = ({ searchTerm, onSearchTermChange, filter, onFilterChange, enrollmentFilter, onEnrollmentFilterChange }) => (
    <div className="dashboard-controls">
        <div className="search-container">
            <input
                type="text"
                placeholder="Search by name, email, or practice..."
                value={searchTerm}
                onChange={(e) => onSearchTermChange(e.target.value)}
                className="search-input"
            />
        </div>
        <div className="filter-container">
            <select
                value={filter}
                onChange={(e) => onFilterChange(e.target.value)}
                className="filter-select">
                <option value="all">All Specialties</option>
                {SPECIALTY_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
            </select>
        </div>
        <div className="filter-container">
            <select
                value={enrollmentFilter}
                onChange={(e) => onEnrollmentFilterChange(e.target.value)}
                className="filter-select">
                <option value="all">All Enrollment Types</option>
                <option value="online">🌐 Online</option>
                <option value="paper">📄 Paper</option>
            </select>
        </div>
    </div>
);

export default DashboardControls;
